export default __webpack_public_path__ + "static/media/badge_outside.0da86e79.png";